import React from 'react'
import { Box, CircularProgress } from '@mui/material'

interface Props {
  removeHeight?: boolean
}
export const LoadingPage = ({ removeHeight }: Props) => {
  return (
    <Box
      sx={(!removeHeight) ? { height: '62vh' } : {}}
      display='flex'
      alignItems='center'
      justifyContent='center'>
      <CircularProgress />
    </Box>
  )
}
